import { useIsMobile } from '@/components/form';
import { Skeleton } from '@/components/ui/skeleton';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import {
  UpdateTermineDesktop,
  UpdateTermineDesktopWrapper,
} from '@/domain/termine/features/UpdateTermin/Desktop/';
import {
  UpdateTermineMobile,
  UpdateTermineMobileWrapper,
} from '@/domain/termine/features/UpdateTermin/Mobile';
import { useUpdateTerminForm } from '@/domain/termine/features/UpdateTermin/shared';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function UpdateTermineContent() {
  const navigate = useNavigate();
  const { year, month } = useParams<{ year: string; month: string }>();
  const isMobile = useIsMobile();
  const { termineWithRecurrences } = useCalendarContext();
  const { id } = useParams();
  const isLoading =
    !termineWithRecurrences || termineWithRecurrences.length === 0;

  const termin = useMemo(
    () => termineWithRecurrences.find((t) => t.id === id),
    [termineWithRecurrences, id],
  );

  const form = useUpdateTerminForm(termin);

  if (isLoading) {
    return <Skeleton className="h-full min-w-max" />;
  }

  function handleClose() {
    navigate(`/termine/uebersicht/${year}/${month}`);
  }

  return isMobile ? (
    <UpdateTermineMobileWrapper onClose={handleClose}>
      <UpdateTermineMobile form={form} isMobile={isMobile} />
    </UpdateTermineMobileWrapper>
  ) : (
    <UpdateTermineDesktopWrapper onClose={handleClose}>
      <UpdateTermineDesktop form={form} isMobile={isMobile} />
    </UpdateTermineDesktopWrapper>
  );
}

export function UpdateTermineWrapper() {
  return <UpdateTermineContent />;
}
